import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
//import { useTranslation } from 'react-i18next';

import { config } from '../../../config';

import UserMenu from '../UserMenu';
import { Divider, List, ListItem } from '@material-ui/core';
import { menus } from 'config/menu';

import { useSelector, useDispatch } from 'react-redux';
import { useAppDrawerSlice } from './slice';
import { selectAppDrawerVisibility } from './slice/selectors';

const drawerWidth = config.UI.drawerWidth;

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.palette.primary.main,
  },
  drawerContainer: {
    overflow: 'auto',
    background: theme.palette.primary.main,
    marginTop: 20,
    color: '#FFFFFF',
    '& a': {
      color: '#FFFFFF',
    },
  },
  topSpacer: {
    height: '60px',
  },
  headerLogo: {
    textAlign: 'center',
    marginBottom: '0.5rem',
    width: `100%`,
    height: 64,
    '& img': {
      margin: '0 auto',
      marginTop: 7,
      height: '80%',
      width: 'auto',
    },
  },
  toolbar: theme.mixins.toolbar,
  userInfo: {
    fontSize: 11,
    padding: '0 0 0 10px',
  },
}));

export function AppDrawer(props) {
  const [userInSession, setUserInSession] = React.useState(false);
  const [menu, setMenu] = React.useState({});
  const [userName, setUserName] = React.useState('');

  const { actions } = useAppDrawerSlice();

  const dispatch = useDispatch();
  const appDrawerVisibility = useSelector(selectAppDrawerVisibility);

  const classes = useStyles();
  //const { t } = useTranslation();

  const _userDTO = localStorage.getItem(config.localUserDTO) || '{}';
  const userDTO = JSON.parse(_userDTO);

  useEffect(() => {
    if (userDTO && userDTO.role) {
      setUserInSession(true);
      if (userDTO.role) {
        const m = menus.filter(m => {
          return m.name === userDTO?.role.name;
        });
        setMenu(m[0]);
        setUserName(userDTO.firstName + ' ' + userDTO.lastName);
      }
    } else {
      setUserInSession(false);
    }
  }, [userDTO, userDTO.firstName, userDTO.role]);

  const hideAppDrawer = () => {
    dispatch(actions.hideAppDrawer());
  };

  return (
    <Drawer
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
      variant={props.variant}
      open={appDrawerVisibility.visibility && appDrawerVisibility.userInSession}
      onClose={hideAppDrawer}
    >
      <div className={classes.topSpacer} />
      <div style={{ background: '#ffffff', height: 60 }}>
        <img
          src="/media/fsjp/logo-cc.png"
          alt="Logo Centro de Conciliación"
          style={{ width: '80%', height: 'auto' }}
        />
      </div>
      <div className={classes.drawerContainer}>
        <List>
          <ListItem>
            {userInSession ? (
              <p className={classes.userInfo}>
                Usuario: <strong>{userName}</strong>
                <br />
                e-mail: <strong>{userDTO.email}</strong>
              </p>
            ) : null}
            {userInSession ? <Divider /> : null}
          </ListItem>
        </List>
        <List>
          {userInSession ? (
            <UserMenu menu={menu} onClick={hideAppDrawer} />
          ) : null}
        </List>
      </div>
    </Drawer>
  );
}
